import { render, staticRenderFns } from "./FollowUpPatientStep4Component.vue?vue&type=template&id=cba402fc&scoped=true&"
import script from "./FollowUpPatientStep4Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep4Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep4Component.vue?vue&type=style&index=0&id=cba402fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba402fc",
  null
  
)

export default component.exports